import { Component, Input, OnInit } from '@angular/core';
import { IonicPage } from 'ionic-angular';
import { ConfigProvider } from '../../providers/config/config';
import { AppVersion } from '@ionic-native/app-version';
import { ToolsProvider } from '../../providers/tools/tools';
import * as debug from 'debug';
import * as _ from 'lodash';

@IonicPage({
  segment: 'update-app-banner',
})
@Component({
  selector: 'update-app-banner',
  templateUrl: 'update-app-banner.html',
})
export class UpdateAppBannerComponent implements OnInit {
  log = debug('app:UpdateAppBanner');

  @Input() mode: 'menu' | 'feed' = 'menu';

  dismissed: boolean = false;
  isVersionOutOfDate: boolean = false;
  configVersion: string; // either the current version or the faked version

  fakedVersionLocalStorageKey = 'FAKED_BANNER_VERSION';
  dismissedVersionLocalStorageKey = 'DISMISSED_BANNER_VERSION';

  constructor(
    public configs: ConfigProvider,
    public appVersion: AppVersion,
    public tools: ToolsProvider
  ) {}

  ngOnInit() {
    if (
      (window && window['cordova']) ||
      localStorage.getItem(this.fakedVersionLocalStorageKey)
    ) {
      if (this.configs.get('versionControl')) {
        this.checkIfVersionOutOfDate();
      } else {
        this.configs.on('loaded', () => {
          this.checkIfVersionOutOfDate();
        });
      }
    }

    // dismissing the banner from one location will remove it from the others without a refresh
    this.tools.on('update-app-banner-dismiss', () => {
      this.dismissed = true;
    });
  }

  async checkIfVersionOutOfDate() {
    try {
      let dismissedVersion = localStorage.getItem(
        this.dismissedVersionLocalStorageKey
      );
      const [
        version,
        versionControl,
      ] = await this.getAppVersionAndVersionRequirements();
      const currentConfigVersion = _.get(
        versionControl,
        'updateAvailableVersionNumber'
      );

      this.configVersion = currentConfigVersion; // used to check if version has been dismissed

      if (dismissedVersion && dismissedVersion === currentConfigVersion) {
        this.dismissed = true;
      } else {
        if (version && currentConfigVersion) {
          this.isVersionOutOfDate = this.tools.isAppVersionNewerThanSecondVersion(
            currentConfigVersion,
            version
          );
        }
      }
    } catch (err) {
      console.error('Error checking app version:', err);
    }
  }

  private getAppVersionAndVersionRequirements() {
    return Promise.all([
      localStorage.getItem(this.fakedVersionLocalStorageKey)
        ? Promise.resolve(
            localStorage.getItem(this.fakedVersionLocalStorageKey)
          )
        : this.appVersion.getVersionNumber(),
      Promise.resolve(this.configs.get('versionControl')),
    ]).then(res => {
      return res;
    });
  }

  goToAppStore() {
    this.tools.openStore();
  }

  dismiss() {
    if (this.configVersion) {
      localStorage.setItem(
        this.dismissedVersionLocalStorageKey,
        this.configVersion
      );
    }

    this.dismissed = true;

    this.tools.emit('update-app-banner-dismiss');
  }
}



// WEBPACK FOOTER //
// ./src/pages/update-app-banner/update-app-banner.ts